import React, { useEffect, useRef, useState } from 'react';
import FoodSelectionModal from './FoodSelectionModal';
import RecipeSelectionModal from './RecipeSelectionModal';
import { CakeIcon, BeakerIcon } from '@heroicons/react/24/outline';
import './UnifiedAddModal.css';

const UnifiedAddModal = ({ 
    close, 
    backendService, 
    modalService,
    onSelectFood,
    onSelectFoods = null,
    initialSelectedFoods = null,
    initialSelectionState = null,
    onSelectRecipe,
    mealId = null,
    initialTab = 'food',
    startWithCamera = false,
    startWithPhotos = false
}) => {
    const [activeTab, setActiveTab] = useState(initialTab);
    const initialPhotoSourceRef = useRef({ startWithCamera, startWithPhotos });

    useEffect(() => {
        initialPhotoSourceRef.current = { startWithCamera: false, startWithPhotos: false };
    }, []);

    // If we start with camera, we should probably default to food tab and pass the prop
    // But if user switches tabs, that state might persist or reset.
    // We only want to trigger camera on initial mount if requested.
    
    return (
        <div className="unified-add-modal">
            {/* Tabs - shared .modal-tabs / .modal-tab from App.css */}
            <div className="modal-tabs">
                <button 
                    className={`modal-tab ${activeTab === 'food' ? 'active' : ''}`}
                    onClick={() => setActiveTab('food')}
                >
                    <CakeIcon style={{ width: 16, height: 16 }} /> Foods
                </button>
                <button 
                    className={`modal-tab ${activeTab === 'recipe' ? 'active' : ''}`}
                    onClick={() => setActiveTab('recipe')}
                >
                    <BeakerIcon style={{ width: 16, height: 16 }} /> Recipes
                </button>
            </div>

            <div className="uam-content">
                {activeTab === 'food' ? (
                    <FoodSelectionModal 
                        close={close}
                        backendService={backendService}
                        onSelect={onSelectFood}
                        onSelectFoods={onSelectFoods}
                        initialSelectedFoods={initialSelectedFoods}
                        initialSelectionState={initialSelectionState}
                        mealId={mealId}
                        startWithCamera={initialPhotoSourceRef.current.startWithCamera}
                        startWithPhotos={initialPhotoSourceRef.current.startWithPhotos}
                        embedded={true}
                    />
                ) : (
                    <RecipeSelectionModal 
                        close={close}
                        backendService={backendService}
                        modalService={modalService}
                        onSelect={onSelectRecipe}
                        embedded={true}
                    />
                )}
            </div>
        </div>
    );
};

export default UnifiedAddModal;
